module.exports = __webpack_public_path__ + "media/images/clearbanc-logo-white-ec499469e757fe4c155e13982dbcce9d.png";